////////////////////////////////////////////////////////////////////////////////
//
// Global Helper functions
//
////////////////////////////////////////////////////////////////////////////////

import Swal from "sweetalert2";

/**
 * Converts a string to a slug
 * @param str
 * @returns {string}
 */
export function slugify(str)
{
    str = str.replace(/^\s+|\s+$/g, '');

    // Make the string lowercase
    str = str.toLowerCase();

    // Remove accents, swap ñ for n, etc
    var from = "ÁÄÂÀÃÅČÇĆĎÉĚËÈÊẼĔȆÍÌÎÏŇÑÓÖÒÔÕØŘŔŠŤÚŮÜÙÛÝŸŽáäâàãåčçćďéěëèêẽĕȇíìîïňñóöòôõøðřŕšťúůüùûýÿžþÞĐđßÆa·/_,:;";
    var to   = "AAAAAACCCDEEEEEEEEIIIINNOOOOOORRSTUUUUUYYZaaaaaacccdeeeeeeeeiiiinnooooooorrstuuuuuyyzbBDdBAa------";
    for (var i=0, l=from.length ; i<l ; i++) {
        str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
    }

    // Remove invalid chars
    str = str.replace(/[^a-z0-9 -]/g, '')
        // Collapse whitespace and replace by -
        .replace(/\s+/g, '_')
        // Collapse dashes
        .replace(/-+/g, '_');

    return str;
}


/**
 * Generates a random string with length
 * @param length
 * @returns {string}
 */
export function random(length = 8) {
    return Math.random().toString(16).substr(2, length);
}


/**
 * Validation of latitude
 * @type {RegExp}
 */
export const validationLatitude = RegExp("^(-?[1-8]?\\d(?:\\.\\d{1,18})?|90(?:\\.0{1,18})?)$");
export const validationLongitude = RegExp("^(-?(?:1[0-7]|[1-9])?\\d(?:\\.\\d{1,18})?|180(?:\\.0{1,18})?)$");

export function confirmDelete() {
    return Swal.fire({
        title: 'Are you sure?',
        text: `You won't be able to revert this!`,
        icon: 'warning', 
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        buttonsStyling: false,
        customClass: {        
            confirmButton: 'btn btn-success btn-fill',
            cancelButton: 'btn btn-danger btn-fill'
        }
    });
}

/**
 * Dowload a file
 * @param filename
 * @param text
 */
export function download(filename, content) {
    var element = document.createElement('a');
    element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(content));
    element.setAttribute('download', filename);

    element.style.display = 'none';
    document.body.appendChild(element);

    element.click();

    document.body.removeChild(element);
}